import React from 'react';

export const RatingColor = ({ props }) => ([
  { text: (<span className={"ratingColor darkGreen"}><span> </span>sign. unauff.</span>) , value: `:excellent` },
  { text: (<span className={"ratingColor green"}><span> </span>nicht sign. unauff.</span>) , value: `:good` },
  { text: (<span className={"ratingColor orange"}><span> </span>nicht sign. auff.</span>) , value: `:middle` },
  { text: (<span className={"ratingColor red"}><span> </span>sign. auff.</span>) , value: `:bad` },
  { text: (<span className={"ratingColor violet"}><span> </span>Sentinel Event</span>) , value: `:sentinel` },
])
